import { KroButton } from "features/components/buttons/kroButton";
import { UserModel } from "common/models/userModel";
import { useNavigate } from "react-router-dom";
import Routes from "router/routes";
import useFetchProfile from "../../hooks/useFetchProfile";
import { LoaderType } from "features/components/loader/kroCircularIndicator";
import KroLoadingIndicator from "features/components/loader/kroCircularIndicator";
import useFetchUserCampaigns from "../../hooks/useFetchUserCampaigns";
const ActionItems = ({ user }: { user: UserModel | null }) => {
  const navigate = useNavigate();

  const { isLoading: isLoadingUsersCampaigns, campaigns } =
    useFetchUserCampaigns(user?.slug ?? "");

  const { isLoading, profile } = useFetchProfile(user?.slug ?? "");

  if (isLoading || isLoadingUsersCampaigns)
    return <KroLoadingIndicator type={LoaderType.FIXED} />;

  const ACTION_ITEMS = [];

  if (campaigns?.length === 0) {
    ACTION_ITEMS.push({
      title: "Create your first fundraiser",
      description: "Create a Fundraiser to raise funds for your cause with Kro",
      icon: "/assets/icons/dash-fundraise.png",
      buttonText: "Create Fundraiser",
      onClick: () => {
        navigate(Routes.CREATE_CAMPAIGN);
      },
    });
  }

  if (!profile) {
    ACTION_ITEMS.push({
      title: "Complete your profile",
      description:
        "Complete your profile information, so donors know you’re real",
      icon: "/assets/icons/dash-person.png",
      buttonText: "Complete Profile",
      onClick: () => {
        navigate(Routes.PROFILE(user?.slug ?? ""));
      },
    });
  }

  if (ACTION_ITEMS.length === 0) {
    return null;
  }

  return (
    <div className="scrollbar-hide mt-6 flex flex-row gap-4 overflow-x-auto lg:gap-8">
      {ACTION_ITEMS.map((item) => (
        <ActionItem key={item.title} {...item} />
      ))}
    </div>
  );
};

const ActionItem = ({
  title,
  description,
  icon,
  onClick,
  buttonText,
}: {
  title: string;
  description: string;
  icon: string;
  onClick: () => void;
  buttonText: string;
}) => {
  return (
    <div className="min-w-[259px] rounded-[8px] border border-neutral-200 bg-[#F9F7F7] p-4 lg:max-w-[422px]">
      <img src={icon} alt={title} className="h-[56px] w-[56px]" />
      <div className="mt-4 flex flex-col gap-y-2">
        <p className="font-inter text-[16px] font-bold leading-[100%] tracking-[-0.5%] text-strong-950">
          {title}
        </p>
        <p className="font-inter text-[16px] font-normal leading-[24px] tracking-[-1.5%] text-neutral-700">
          {description}
        </p>
      </div>

      <KroButton className="mt-4 w-full" onclick={onClick} title={buttonText} />
    </div>
  );
};

export default ActionItems;
